module.exports = __webpack_public_path__ + "static/img/app5.108f961.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app5.jpg
// module id = nrfC
// module chunks = 1